module.exports = __webpack_public_path__ + "media/assets/images/icons/attachments-icon3-282785904f0d890656497016a15d2b07.svg";